import React, { useState } from 'react';

const slugify = (name) => name.toLowerCase().trim().replace(/\s+/g, '-');

const colorForName = (name) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 55%, 45%)`;
};

const BrandLogo = ({ make, size = 80 }) => {
  const [errored, setErrored] = useState(false);
  const slug = slugify(make);

  if (errored) {
    return (
      <div
        style={{
          ...styles.fallback,
          width: size,
          height: size,
          background: colorForName(make)
        }}
      >
        {make}
      </div>
    );
  }

  return (
    <img
      src={`/logos/${slug}.png`}
      alt={make}
      style={{ ...styles.img, width: size, height: size }}
      onError={() => setErrored(true)}
    />
  );
};

const styles = {
  img: {
    objectFit: 'contain',
    display: 'block'
  },
  fallback: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '12px',
    color: 'white',
    fontWeight: '700',
    fontSize: '13px',
    textAlign: 'center',
    padding: '6px',
    boxSizing: 'border-box',
    lineHeight: 1.1,
    wordBreak: 'break-word'
  }
};

export default BrandLogo;
